import { Link } from "react-router-dom";
import { ArrowUpRight, Cloud, Shield, Brain, GitMerge, Boxes, Briefcase } from "lucide-react";
import SEO from "../components/SEO";
import { SERVICES } from "../data/services";

const ICONS = { cloud: Cloud, shield: Shield, brain: Brain, "git-merge": GitMerge, boxes: Boxes, briefcase: Briefcase };

const Services = () => (
  <>
    <SEO title="Services — Six integrated practices" description="DevSecOps Engineering, Cloud, Platform Engineering & Kubernetes, Cybersecurity, AI/ML, and Project & Program Management — for federal and Fortune 500 clients." path="/services" />

    <section style={{ paddingTop: 120, paddingBottom: 80 }}>
      <div className="container-grav">
        <div className="eyebrow" style={{ marginBottom: 28 }}><span className="sep" />Capabilities</div>
        <h1 className="display-xl" style={{ maxWidth: 1200 }}>
          Six practices.<br />
          <span style={{ color: "var(--green)", fontStyle: "italic", fontWeight: 800 }}>One accountable partner.</span>
        </h1>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10" style={{ marginTop: 48 }}>
          <div className="lg:col-span-6 lg:col-start-7">
            <p className="lede">
              Advisory, engineering, and operations across DevSecOps, cloud, platform engineering, cybersecurity, AI/ML, and program management — engineered for federal mission and enterprise scale.
            </p>
          </div>
        </div>
      </div>
    </section>

    {/* Editorial rows */}
    <section style={{ borderTop: "1px solid var(--ink)" }}>
      <div className="container-grav">
        {SERVICES.map((s) => {
          const Icon = ICONS[s.icon];
          return (
            <Link
              to={`/services/${s.slug}`}
              key={s.slug}
              data-testid={`service-row-${s.slug}`}
              className="row-editorial row-services"
              style={{
                textDecoration: "none",
                color: "var(--ink)",
                transition: "background-color 300ms ease",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.background = "var(--bg-alt)")}
              onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
            >
              <div className="eyebrow">{s.code}</div>
              <div style={{ width: 56, height: 56, borderRadius: "50%", background: "var(--green-bg)", color: "var(--green)", display: "inline-flex", alignItems: "center", justifyContent: "center" }}>
                {Icon && <Icon size={24} strokeWidth={1.75} />}
              </div>
              <div>
                <h3 className="display-md" style={{ marginBottom: 10 }}>{s.title}</h3>
                <p className="body-md" style={{ maxWidth: 640 }}>{s.tagline}</p>
              </div>
              <div className="svc-arrow" style={{ color: "var(--green)", transition: "transform 300ms ease" }}><ArrowUpRight size={36} strokeWidth={1.5} /></div>
            </Link>
          );
        })}
      </div>
    </section>

    {/* CTA */}
    <section className="section">
      <div className="container-grav" style={{ textAlign: "center" }}>
        <h2 className="display-lg" style={{ maxWidth: 820, margin: "0 auto" }}>
          Not sure where to start? <span className="text-green">We scope it with you.</span>
        </h2>
        <div style={{ marginTop: 40 }}>
          <Link to="/contact" className="btn">Request consultation <span className="arrow"><ArrowUpRight size={14} /></span></Link>
        </div>
      </div>
    </section>
  </>
);

export default Services;
